import { h, render } from 'preact';
import { ExternalAd, ExternalAdToast } from './ExternalAd';

/** Mount an external ad into every `[data-external-ad="<slot>"]` element on the page. */
export default function mountExternalAds(): void {
    document.querySelectorAll<HTMLElement>('[data-external-ad]').forEach((node) => {
        const slot = node.dataset.externalAd;
        if (!slot) return;
        render(h(slot.endsWith('.toast') ? ExternalAdToast : ExternalAd, { slot }), node);
    });
}
